<template>
  <v-container>
    <v-row class="grid text-center">
      <template v-if="!loading && lots.length">
        <v-col v-for="lot in lots" cols="12" sm="12" md="6" lg="4" :key="lot.id">
          <lot-item :key="lot.title" :item="lot" />
        </v-col>
      </template>
      <v-col v-else-if="loading">
        <loader in-block />
      </v-col>
      <v-col v-else>
        <div class="no-entities-message">
          {{ $t('nobody_is_selling_now') }}
        </div>
      </v-col>
    </v-row>
    <create-buy-request ref="createBuyRequestDialog" />
  </v-container>
</template>
<script>
import LotItem from '@/components/Auction/LotItem'
import CreateBuyRequest from '@/components/Auction/Modals/CreateBuyRequest'
import Loader from '@/components/Core/Loader'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'BuyTab',
  components: {
    LotItem,
    CreateBuyRequest,
    Loader
  },
  async mounted () {
    await this.loadLots(this.token)
      .finally(() => {
        this.loading = false
      })
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters({
      token: 'user/getAccessToken',
      lots: 'auction/getLots'
    })
  },
  methods: {
    ...mapActions({
      loadLots: 'auction/loadLots'
    }),
    openBuyRequestModal () {
      this.$refs.createBuyRequestDialog.openDialog()
    }
  }
}
</script>
<style scoped>
.grid {
    margin: 50px 30px;
}

.no-entities-message {
    margin: 0 auto;
    max-width: 300px;
    padding: 20px 40px;
    background: #E8FFFA;
    border: 1px solid #BDE5DD;
    border-radius: 10px;
    color: #649187;
}
</style>
